import App from './App.svelte';
import firebase from "@firebase/app";
import "@firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyClsWfJBO1EaYw4_ANpv3VdPBrOxO1nLyU",
    authDomain: "worship-clicker.firebaseapp.com",
    projectId: "worship-clicker",
    storageBucket: "worship-clicker.appspot.com",
    messagingSenderId: "350437947608",
    appId: "1:350437947608:web:ed7b0aabcf8f107709bfad",
    measurementId: "G-L4QKNK6CLF"
};
firebase.initializeApp(firebaseConfig);
const app = new App({
    target: document.body,
});
export default app;
